// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1X-0b","productName":"Table_productName__35oLw"};